import { useLocation } from 'react-router'
import { Footer1 } from '../components/footers/Footer1'
import { Footer2 } from '../components/footers/Footer2'

export default function FooterSection() {
  const location = useLocation()
  const isHome2 = location?.pathname.includes('/home-2')

  if (isHome2) {
    return <Footer2 />
  } else {
    return <Footer1 />
  }
}
